import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractSearchInput} from "../abstract-search-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIEditSearchInputComponent),
            multi: true
        }
    ],
    selector: "fui-edit-search-input",
    styleUrls: ["./edit-search-input.component.scss"],
    templateUrl: "./edit-search-input.component.html",
    standalone: false
})
export class FUIEditSearchInputComponent extends FUIAbstractSearchInput {
    constructor(elementRef: ElementRef,
                changeDetectorRef: ChangeDetectorRef) {
        super(elementRef, changeDetectorRef);
    }
}
